import { Controller } from "@hotwired/stimulus";

// Scrolls to the element named by targetValue as soon as the marker element appears.
// Used after Turbo morph refreshes, which preserve scroll position and ignore URL anchors,
// to reveal content that was just added out of view (e.g. a panel added on the review page).
export default class extends Controller {
  static values = { target: String };

  connect() {
    document
      .getElementById(this.targetValue)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });

    // The marker removes itself so the next render's marker is a genuinely new element.
    // Left in place, a Turbo morph would update it in place without reconnecting this
    // controller, and only the first scroll would ever fire.
    this.element.remove();
  }
}
